import {useState, useEffect} from "react";
import {useLocation, useParams} from "react-router-dom";
import {GobernanzaService} from "saneamiento/service";
import {PageLayout} from "base/layout";
import {GobernanzaSubPageMenu} from "../menu";
import {useAppConfig} from "base/provider";

const ViewPoligonoPage = () => {
    const {setSubpagePath} = useAppConfig();

    const {codigo} = useParams();
    const [gobernanza, setGobernanza] = useState(null);
    const location = useLocation();

    useEffect(() => {
        GobernanzaService.get(codigo).then(data => {
            setGobernanza(data);
            setSubpagePath([
                {
                    name: "Gobernanza",
                    path: "gobernanza/summary",
                },
            ]);
        });
        return () => {
            setGobernanza(null);
            setSubpagePath([]);
        };
    }, [codigo, location.state?.lastRefreshDate]);

    return (
        gobernanza && (
            <PageLayout
                menu={<GobernanzaSubPageMenu gobernanza={gobernanza} />}
                context={[gobernanza]}
                subPage={true}
            />
        )
    );
};

export default ViewPoligonoPage;
